import React from 'react'
import { LoadingLogo } from '@labrav/react-components'
import { useSelector, useDispatch } from '../../../store'
import { useStyles } from './ListingCardCreationFormikWrapper.styles'
import { ListingDesignForm } from './ListingDesignForm/LsitingDesignForm'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'

export const ListingCardCreationFormikWrapper: React.FC = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()

  const isLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.CREATE_LISTING_CARD)
  )
  if (isLoading) {
    return <LoadingLogo />
  }

  return (
    <div
      className={classes.listingContainer}
      data-testid="storefront-template-form"
    >
      <div
        className={classes.formStyle}
        data-testid="formik-container-listing-card-creation"
      >
        <div className={classes.listingForm}>
          <ListingDesignForm />
        </div>
      </div>
    </div>
  )
}
